import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ComprehensiveBrandingMarketingSolutions from "./sections/ComprehensiveBrandingMarketingSolutions";
import OurServices from "./sections/OurServices";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ComprehensiveBrandingMarketingSolutions />
      <OurServices />
      <Footer />
    </div>;
}